import { render, staticRenderFns } from "./SalaryRules.vue?vue&type=template&id=ccbcb4e2&scoped=true&"
import script from "./SalaryRules.vue?vue&type=script&lang=js&"
export * from "./SalaryRules.vue?vue&type=script&lang=js&"
import style0 from "./SalaryRules.vue?vue&type=style&index=0&id=ccbcb4e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbcb4e2",
  null
  
)

export default component.exports